import React, { useMemo } from 'react'
import { Avatar } from 'antd'
import { PreviewImg } from '../../helper/imagepath'
import { appendImageURL } from '../../helper/function'

const ChatHeader = ({ client, cleaners }) => {
    
  const HeaderTitle = useMemo(
    () => (client ? `${client?.first_name} ${client?.last_name} , ${cleaners?.first_name} ${cleaners?.last_name}` : ''),
    [client, cleaners]
  )

  return (
    <div className="chat-header">
      <div className="chat-user-info">
        <div className="user-image d-flex" style={{ alignItems: 'center' }}>
          <Avatar.Group>
            <Avatar src={client?.profile_image ? appendImageURL(client?.profile_image) : PreviewImg} alt="video-icon" />
            <Avatar src={cleaners?.profile_image ? appendImageURL(cleaners?.profile_image) : PreviewImg} alt="video-icon" />
          </Avatar.Group>
        </div>
        <div className="user-detail">
          <div className="user-name mb-1">{HeaderTitle}</div>
        </div>
      </div>
    </div>
  )
}
export default ChatHeader
